export enum OfferStates {
    LOCKED = 'locked',
    IMPORTED = 'imported',
    ORDERED = 'ordered',
    DRAFT = 'draft',
}
